import {WinPresentationController} from "../WinPresentationController";
import {WalkOfShame} from "../../WalkOfShame";
import {WalkOfShameGameMode} from "../../server/WalkOfShameGameMode";
import {TimelineLite} from "gsap";
import {WalkOfShameSound} from "../../sound/WalkOfShameSound";

export class ReSpinEndController extends WinPresentationController {
    constructor() {
        super("ReSpinEndController", false);
    }

    protected async createWinAnimation(): Promise<void> {
        const tl: TimelineLite = new TimelineLite();

        tl.add([
            () => {
                if ((WalkOfShame.model.parsedGameData.mode === WalkOfShameGameMode.RESPIN && WalkOfShame.model.parsedGameData.nextMode === WalkOfShameGameMode.NORMAL) ||
                    (WalkOfShame.model.parsedGameData.mode === WalkOfShameGameMode.SUPER_FREESPIN_RESPIN && WalkOfShame.model.parsedGameData.nextMode === WalkOfShameGameMode.SUPER_FREESPIN)) {
                    WalkOfShame.logo.onModeChange(WalkOfShame.model.parsedGameData.nextMode, false);
                }

                if (WalkOfShame.model.parsedGameData.currentWinRatioConfig && WalkOfShame.model.parsedGameData.currentWinRatioConfig.ratio < 15) {
                    WalkOfShameSound.soundPlayer.playTrack({
                        name: WalkOfShameSound.WALK_OF_SHAME_END
                    });

                    WalkOfShameSound.switchMusic({
                        name: WalkOfShameSound.getMusicNameByMode(WalkOfShame.model.parsedGameData.nextMode),
                        volume: 1
                    }, undefined, {
                        name: "",
                        to: 0,
                        duration: 200
                    });
                }

                WalkOfShameSound.soundPlayer.playTrack({
                    name: WalkOfShameSound.X_SPLIT_LIGHTER_OFF
                });
            },
            WalkOfShame.stickyS2.playS2Animation("respin_end", false)
        ]);

        await tl;
    }

    protected hasWin(): boolean {
        return ((WalkOfShame.model.parsedGameData.mode.indexOf("RESPIN") > -1) && (WalkOfShame.model.parsedGameData.nextMode === WalkOfShameGameMode.NORMAL || WalkOfShame.model.parsedGameData.nextMode === WalkOfShameGameMode.SUPER_FREESPIN));
    }
}